import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setError, setErroAPI, setSuccess } from '../common/toast/toast';
import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ValueBox from  '../common/widget/valueBox'
import Row from  '../common/layout/row'
import InfoBox from  '../common/infoBox/infoBox'
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import Button from '../common/button/button';
import ButtonTable from '../common/table/buttonTable';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import ReactExport from 'react-export-excel-fixed-xlsx';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import FormatUtils from '../common/formatUtils/FormatUtils';
import imagemSoLogoColorida from '../assets/images/sologo.png';
import imagemSoLogoAmarela from '../assets/images/sologoamarela.png';
import imagemFundo from '../assets/images/praia_mar_fundo.jpg';
import logoSaoJoao from '../assets/images/logo_sao_joao.png';
import logoTurismoResponsavel from '../assets/images/logo_turismo_responsavel.png';
import logoMsc from '../assets/images/logo_msc.png';
import logoAzul from '../assets/images/logo_azul.png';
import logoGol from '../assets/images/logo_gol.png';
import logoLatam from '../assets/images/logo_latam.png';

import { 
	enviarMensagem, carregarLinkBeneficio
} from './dashboardActions';

import contentCardBody from '../common/template/contentCardBody';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputMask from '../common/form/labelAndInputMask';

class Dashboard extends Component {

	state = {
		modoTela: 'menu'
	}

	constructor(props) {
		super(props);
    }

    componentDidMount() {
		
		const idIntervalAux = setInterval(() => {
			if (this.props.usuarioCarregado && this.props.usuarioCarregado.cpf_beneficio) {
				clearInterval(idIntervalAux);
				this.props.carregarLinkBeneficio(this.props.usuarioCarregado.cpf_beneficio);
			}
		}, 1000);
		
		this.idInterval = setInterval(() => {
			if (this.props.usuarioCarregado && this.props.usuarioCarregado.cpf_beneficio) {
				this.props.carregarLinkBeneficio(this.props.usuarioCarregado.cpf_beneficio);
			}
		}, 60000);
    }

	componentWillUnmount() {
		clearInterval(this.idInterval);
	}

    render() {

        return (
			<section className='content'
				style={{
					backgroundImage: `url(${imagemFundo})`,
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
					minHeight: '100%',
					width: '100%'
				}}>

				{this.state.modoTela == 'menu' ? this.menu() : null}

				{this.state.modoTela == 'reserva' ? this.reserva() : null}

				{this.state.modoTela == 'indique' ? this.indique() : null}

				{this.state.modoTela == 'associar' ? this.associar() : null}

				{this.state.modoTela == 'carteirinha' ? this.carteirinha() : null}

			</section>
        )
	}

	menu() {

		const card = {
			width: 140,
			height: 140,
			margin: 8,
			backgroundColor: '#0042E2',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'space-between',
			alignItems: 'center',
			borderRadius: 10
		};

		const cardIcon = {
			width: 60,
			height: 60,
			backgroundColor: '#FFCC00',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			alignItems: 'center',
			marginTop: 12,
			padding: 8,
			borderRadius: 30
		};

		const icon = {
			fontSize: 30,
			fomtWeight: 'bold',
			color: '#0042E2'
		};

		const cardLabel = {
			height: 60,
			fontSize: 20,
			color: '#ffffff',
			marginBottom: 12,
			textAlign: 'center',
			display: 'flex',
			alignItems: 'center'
		};
		
		return (
			<Row alignCenter>
				
				{this.parques()}

				<Grid cols='12 10 6 4'>
					<div 
						style={{ 
							display: 'flex',
							flexDirection: 'row',
							flexWrap: 'wrap',
							justifyContent: 'center',
							opacity: 0.9
						}}>

						<a style={card}
							href='https://heyzine.com/flip-book/26eceeecfd.html'
							target='_blank'>

							<div style={cardIcon}>
								<i class='fas fa-book' style={icon}></i>
							</div>

							<div style={cardLabel}>Revista</div>
						</a>

						<a style={card}
							href=''
							onClick={event => {
								event.preventDefault();

								this.setState({
									...this.state,
									modoTela: 'reserva',
									registroReserva: {
										tipo: this.props.usuarioCarregado.id ? 'Sócio' : 'Convite'
									}
								});

								setTimeout(() => {
									window.scrollTo(0, 0);
								}, 20);
							}}>

							<div style={cardIcon}>
								<i class='fas fa-calendar-alt' style={icon}></i>
							</div>

							<div style={cardLabel}>Reserva</div>
						</a>

						<a style={card}
							href={`https://wa.me/554732691650`}
							target='_blank'>

							<div style={cardIcon}>
								<i class='fab fa-whatsapp' style={icon}></i>
							</div>

							<div style={cardLabel}>WhatsApp</div>
						</a>

						<a style={card}
							href='https://www.vivahospedagens.com.br'
							target='_blank'>

							<div style={cardIcon}>
								<i class='fas fa-globe' style={icon}></i>
							</div>

							<div style={cardLabel}>Nosso Site</div>
						</a>

						<a style={card}
							href='https://www.vivahospedagens.com.br/pacotes'
							target='_blank'>

							<div style={cardIcon}>
								<i class='fas fa-umbrella-beach' style={icon}></i>
							</div>

							<div style={cardLabel}>Pacotes de Viagens</div>
						</a>

						<a style={card}
							href='https://vivahospedagens.com.br/locais_ofertas'
							target='_blank'>

							<div style={cardIcon}>
								<i class='fas fa-gift' style={icon}></i>
							</div>

							<div style={cardLabel}>Ofertas</div>
						</a>

						{!!this.props.usuarioCarregado.id && //Sócio
						<a style={card}
							href='https://drive.google.com/drive/folders/1L8Xv9qF9aU_sIP3El7f6k18_X59iWruL?usp=sharing'
							target='_blank'>

							<div style={cardIcon}>
								<i class='fas fa-clipboard-list' style={icon}></i>
							</div>

							<div style={cardLabel}>Tutorial</div>
						</a>}

						{!!this.props.usuarioCarregado.id && //Sócio
						<a style={card}
							href=''
							onClick={event => {
								event.preventDefault();

								if (this.props.usuarioCarregado.id) {
									this.setState({
										...this.state,
										modoTela: 'carteirinha',
										registroIndicar: {}
									});

									setTimeout(() => {
										window.scrollTo(0, 0);
									}, 20);
								} else {
									setError('Você ainda não possui carteirinha. Associe-se!!');
								}
							}}>

							<div style={cardIcon}>
								<i class='fas fa-credit-card' style={icon}></i>
							</div>

							<div style={cardLabel}>Carteirinha</div>
						</a>}

						<a style={card}
							href='https://linktr.ee/vivahospedagemelazer?fbclid=PAZXh0bgNhZW0CMTEAAabLHhsHILATt6y_-or-W54XAtvEYHO4w4Csx1L7f4ybyhWOv7KJhX-mdWU_aem_HqrrtsRRaZEOSbL68U2OfA'
							target='_blank'>

							<div style={cardIcon}>
								<i class='fas fa-link' style={icon}></i>
							</div>

							<div style={cardLabel}>Mídias Sociais</div>
						</a>

						<a style={card}
							href='https://vivahospedagens.com.br/depoimentos'
							target='_blank'>

							<div style={cardIcon}>
								<i class='fas fa-comments' style={icon}></i>
							</div>

							<div style={cardLabel}>Depoimentos</div>
						</a>
						
						<a style={card}
							href=''
							onClick={event => {
								event.preventDefault();

								this.setState({
									...this.state,
									modoTela: 'indique',
									registroIndicar: {}
								});

								setTimeout(() => {
									window.scrollTo(0, 0);
								}, 20);
							}}>

							<div style={cardIcon}>
								<i class='fas fa-users' style={icon}></i>
							</div>

							<div style={cardLabel}>Indique</div>
						</a>

						<a style={card}
							href='https://www.google.com/maps/place/Viva+Hospedagem+e+Lazer/@-27.1355119,-48.5981075,1026m/data=!3m2!1e3!4b1!4m6!3m5!1s0x94fc32a2f6355a0f:0x35f59a8036325d33!8m2!3d-27.1355119!4d-48.5981075!16s%2Fg%2F11jh2926v6?entry=ttu&g_ep=EgoyMDI1MDMyNC4wIKXMDSoASAFQAw%3D%3D'
							target='_blank'>

							<div style={cardIcon}>
								<i class='fas fa-map-marker-alt' style={icon}></i>
							</div>

							<div style={cardLabel}>Endereço</div>
						</a>

						{!!this.props.usuarioCarregado.id && //Sócio
						<a style={card}
							href=''
							onClick={event => {
								event.preventDefault();

								window.open('https://parksnet.com.br/destino/santa-catarina?bookingAgency=5711&cupom=VIVAHOSPEDAGEM', '_blank');
								
								//this.setParques(true);
							}}>

							<div style={cardIcon}>
								<i class='fas fa-tram' style={icon}></i>
							</div>

							<div style={cardLabel}>Parques</div>
						</a>}

						<a style={card}
							href=''
							onClick={event => {
								event.preventDefault();

								this.setState({
									...this.state,
									modoTela: 'associar',
									registroAssociar: {}
								});

								setTimeout(() => {
									window.scrollTo(0, 0);
								}, 20);
							}}>

							<div style={cardIcon}>
								<i class='fas fa-file-signature' style={icon}></i>
							</div>

							<div style={cardLabel}>Associe-se</div>
						</a>

						{this.props.linkBeneficiario &&
						<a style={card}
							href={this.props.linkBeneficiario}
							target='_blank'>
							<div style={cardIcon}>
								<i class='fas fa-tags' style={icon}></i>
							</div>

							<div style={cardLabel}>Viva Benefícios</div>
						</a>}
					</div>
				</Grid>
			</Row>
		);
	}

	reserva() {
		
		const rowItem = {
			marginTop: 12,
			marginBottom: 4,
			paddingRight: 8
		};

		return (
			<div 
				style={{ 
					backgroundColor: 'rgba(255, 255, 255, 0.7)',
					padding: 4
				}}>

				<Row alignCenter>
					<Grid cols='12 6 4 3'>
						{/*
						<Row style={{ ...rowItem }}>
							<Grid cols='6 6 6 6'>
								<button 
									type='button'
									class={`btn btn-block btn-${this.state.registroReserva.tipo == 'Sócio' ? 'primary' : 'secondary'} btn-sm`}
									onClick={() => {										
										this.setState({
											...this.state,
											registroReserva: {
												...this.state.registroReserva,
												tipo: 'Sócio'
											}
										});
									}}>Sócio</button>
							</Grid>
							<Grid cols='6 6 6 6'>
								<button 
									type='button'
									class={`btn btn-block btn-${this.state.registroReserva.tipo == 'Convite' ? 'primary' : 'secondary'} btn-sm`}
									onClick={() => {										
										this.setState({
											...this.state,
											registroReserva: {
												...this.state.registroReserva,
												tipo: 'Convite'
											}
										});
									}}>Convite</button>
							</Grid>
						</Row>*/}

						{this.state.registroReserva.tipo == 'Convite' && 
						<Row style={rowItem}>							
							<LabelAndInput						
								label='Número do Convite:'
								placeholder=''
								cols='12 12 12 12'
								value={this.state.registroReserva.numero_convite}
								onChange={data => {
									this.setState({
										...this.state,
										registroReserva: {
											...this.state.registroReserva,
											numero_convite: data.target.value
										}
									});
								}} />
						</Row>}

						{this.state.registroReserva.tipo == 'Sócio' &&
						<Row style={rowItem}>							
							<LabelAndInput						
								label='Local Desejado:'
								placeholder=''
								cols='12 12 12 12'
								value={this.state.registroReserva.local}
								onChange={data => {
									this.setState({
										...this.state,
										registroReserva: {
											...this.state.registroReserva,
											local: data.target.value
										}
									});
								}} />
						</Row>}

						{this.state.registroReserva.numero_convite && 
						<Row style={rowItem}>
							<Grid cols='12 12 12 12'>
								<p>Escolha o Local:</p>						
							</Grid>
							{[
								'Bombinhas - SC',
								'Itapema - SC',
								'Piratuba - SC',
								'Capão da Canoa - RS',
								'Torres - RS',
								'Serra Gaúcha - RS',
								'Foz do Iguaçu - PR'
							].map(item => (
								<Grid key={item} cols='12 12 12 12' style={{ marginTop: 2, marginBottom: 2 }}>
									<button 
										type='button'
										class={`btn btn-block btn-${this.state.registroReserva.local == item ? 'primary' : 'secondary'} btn-sm`}
										onClick={() => {										
											this.setState({
												...this.state,
												registroReserva: {
													...this.state.registroReserva,
													local: item
												}
											});
										}}>{item}</button>
								</Grid>
							))}
						</Row>}

						{this.state.registroReserva.local && 
						<Row style={rowItem}>
							<Grid cols='12 12 12 12' style={{ marginTop: 2, marginBottom: 2 }}>
								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										justifyContent: 'center',
										alignItems: 'center'
									}}>
									<div style={{ width: 150, alignItems: 'left' }}>Adultos</div>
									<button 
										type='button'
										class={`btn btn-block btn-secondary btn-sm`}
										style={{ 
											width: 40
										}}
										onClick={() => {										
											this.setState({
												...this.state,
												registroReserva: {
													...this.state.registroReserva,
													quantidade_adultos: (this.state.registroReserva.quantidade_adultos || 0) == 0 
														? 0
														: (this.state.registroReserva.quantidade_adultos || 0) - 1
												}
											});
										}}>-</button>
									<div style={{ width: 40, textAlign: 'center', fontWeight: 'bold' }}>{(this.state.registroReserva.quantidade_adultos || 0)}</div>
									<button 
										type='button'
										class={`btn btn-block btn-secondary btn-sm`}
										style={{ 
											width: 40
										}}
										onClick={() => {										
											this.setState({
												...this.state,
												registroReserva: {
													...this.state.registroReserva,
													quantidade_adultos: (this.state.registroReserva.quantidade_adultos || 0) + 1
												}
											});
										}}>+</button>
								</div>
							</Grid>
							<Grid cols='12 12 12 12' style={{ marginTop: 2, marginBottom: 2 }}>
								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										justifyContent: 'center',
										alignItems: 'center'
									}}>
									<div style={{ width: 150, alignItems: 'left' }}>Crianças (até 17)</div>
									<button 
										type='button'
										class={`btn btn-block btn-secondary btn-sm`}
										style={{ 
											width: 40
										}}
										onClick={() => {
											
											const quantidade = (this.state.registroReserva.quantidade_criancas || 0) == 0 
												? 0
												: (this.state.registroReserva.quantidade_criancas || 0) - 1;

											this.setState({
												...this.state,
												registroReserva: {
													...this.state.registroReserva,
													quantidade_criancas: quantidade,
													idade_criancas: new Array(quantidade).keys().map(item => ({
														id: item + 1,
														idade: null
													}))
												}
											});
										}}>-</button>
									<div style={{ width: 40, textAlign: 'center', fontWeight: 'bold' }}>{(this.state.registroReserva.quantidade_criancas || 0)}</div>
									<button 
										type='button'
										class={`btn btn-block btn-secondary btn-sm`}
										style={{ 
											width: 40
										}}
										onClick={() => {
											
											const quantidade = (this.state.registroReserva.quantidade_criancas || 0) + 1;

											this.setState({
												...this.state,
												registroReserva: {
													...this.state.registroReserva,
													quantidade_criancas: quantidade,
													idade_criancas: Array.from(Array(quantidade).keys()).map(item => ({
														id: item + 1,
														idade: null
													}))
												}
											});
										}}>+</button>
								</div>
							</Grid>

							{(this.state.registroReserva.idade_criancas || []).map(item => {

								return (								
									<Select				
										key={item.id}
										label={`Idade da Criança ${item.id}`}
										placeholder=''
										cols='12 12 12 12'
										options={Array.from(Array(18).keys()).map(idade => ({
											id: idade == 0 ? 'Menos de 1 ano' : (
												idade == 1 ? '1 ano' 
												: `${idade} anos`
											),
											valor: idade == 0 ? 'Menos de 1 ano' : (
												idade == 1 ? '1 ano' 
												: `${idade} anos`
											)
										}))}
										value={item.idade}
										onChange={value => {
											this.setState({
												...this.state,
												registroReserva: {
													...this.state.registroReserva,
													idade_criancas: (this.state.registroReserva.idade_criancas || []).map(itemAux => {
														if (itemAux.id == item.id) {
															return {
																...itemAux,
																idade: value
															}
														} else {
															return itemAux;
														}
													})
												}
											});
										}} />
								);
							})}

							<Grid cols='12 12 12 12' style={{ marginTop: 2, marginBottom: 2 }}>
								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										justifyContent: 'center',
										alignItems: 'center'
									}}>
									<div style={{ width: 150, alignItems: 'left' }}>Pets</div>
									<button 
										type='button'
										class={`btn btn-block btn-secondary btn-sm`}
										style={{ 
											width: 40
										}}
										onClick={() => {										
											this.setState({
												...this.state,
												registroReserva: {
													...this.state.registroReserva,
													quantidade_pets: (this.state.registroReserva.quantidade_pets || 0) == 0 
														? 0
														: (this.state.registroReserva.quantidade_pets || 0) - 1
												}
											});
										}}>-</button>
									<div style={{ width: 40, textAlign: 'center', fontWeight: 'bold' }}>{(this.state.registroReserva.quantidade_pets || 0)}</div>
									<button 
										type='button'
										class={`btn btn-block btn-secondary btn-sm`}
										style={{ 
											width: 40
										}}
										onClick={() => {										
											this.setState({
												...this.state,
												registroReserva: {
													...this.state.registroReserva,
													quantidade_pets: (this.state.registroReserva.quantidade_pets || 0) + 1
												}
											});
										}}>+</button>
								</div>
							</Grid>
							<Grid cols='12 12 12 12' style={{ marginTop: 2, marginBottom: 2 }}>
								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										justifyContent: 'center',
										alignItems: 'center'
									}}>
									<div style={{ width: 150, alignItems: 'left' }}>Dias de reserva</div>
									<button 
										type='button'
										class={`btn btn-block btn-secondary btn-sm`}
										style={{ 
											width: 40
										}}
										onClick={() => {										
											this.setState({
												...this.state,
												registroReserva: {
													...this.state.registroReserva,
													quantidade_dias: (this.state.registroReserva.quantidade_dias || 0) == 0 
														? 0
														: (this.state.registroReserva.quantidade_dias || 0) - 1
												}
											});
										}}>-</button>
									<div style={{ width: 40, textAlign: 'center', fontWeight: 'bold' }}>{(this.state.registroReserva.quantidade_dias || 0)}</div>
									<button 
										type='button'
										class={`btn btn-block btn-secondary btn-sm`}
										style={{ 
											width: 40
										}}
										onClick={() => {										
											this.setState({
												...this.state,
												registroReserva: {
													...this.state.registroReserva,
													quantidade_dias: (this.state.registroReserva.quantidade_dias || 0) + 1
												}
											});
										}}>+</button>
								</div>
							</Grid>

							<LabelAndInputMask
								label='Data:'
								placeholder=''
								cols='12 6 6 6'
								mask='99/99/9999'
								value={this.state.registroReserva.data_agenda}
								onChange={data => {
									this.setState({
										...this.state,
										registroReserva: {
											...this.state.registroReserva,
											data_agenda: data.target.value
										}
									});
								}} />

							<LabelAndInputMask
								label='Celular de Contato:'
								placeholder=''
								cols='12 12 12 12'
								value={this.state.registroReserva.celular}
								mask='(99) 9 9999-9999'
								onChange={data => {
									this.setState({
										...this.state,
										registroReserva: {
											...this.state.registroReserva,
											celular: data.target.value
										}
									});
								}} />

							<LabelAndInput						
								label='Informações Adicionais:'
								placeholder=''
								cols='12 12 12 12'
								value={this.state.registroReserva.informacao_adicional}
								onChange={data => {
									this.setState({
										...this.state,
										registroReserva: {
											...this.state.registroReserva,
											informacao_adicional: data.target.value
										}
									});
								}} />
						</Row>}


						<Row alignCenter style={{ paddingBottom: 50, marginTop: 20 }}>
							{(this.state.registroReserva.data_agenda 
								&& this.state.registroReserva.celular) &&
							<Grid cols='6 6 6 6'>
								<button 
									type='button'
									class='btn btn-block btn-dark btn-sm'
									onClick={() => {
										let mensagem = 'Olá, quero fazer minha reserva: \n'
											+ `\nTipo: ${this.state.registroReserva.tipo}`
											+ `\nNúmero: ${
												this.state.registroReserva.tipo == 'Sócio' 
												? this.props.usuarioCarregado.numero_contrato
												: this.state.registroReserva.numero_convite
											}`
											+ (this.state.registroReserva.tipo == 'Sócio'  ? 
											`\nNível: ${this.props.usuarioCarregado.nivel_cliente || ''}` : '')
											+ `\nLocal: ${this.state.registroReserva.local || ''}`
											+ `\nAdultos: ${this.state.registroReserva.quantidade_adultos || 0}`
											+ `\nCrianças: ${this.state.registroReserva.quantidade_criancas || 0}`
											+ `\n` +(this.state.registroReserva.idade_criancas || []).map(item =>
												`Criança ${item.id}: ${item.idade || 'Não Informada'}`
											).join('\n')
											+ `\nPets: ${this.state.registroReserva.quantidade_pets || 0}`
											+ `\nDias de Reserva: ${this.state.registroReserva.quantidade_dias || 0}`
											+ `\nData: ${this.state.registroReserva.data_agenda || ''}`
											+ `\nCelular: ${this.state.registroReserva.celular || ''}`
											+ (this.state.registroReserva.informacao_adicional 
												? `\nInformações Adicionais: ${this.state.registroReserva.informacao_adicional}`
												: null
											);

										// this.props.enviarMensagem({
										// 	texto: mensagem
										// });

										let link = `https://wa.me/554732691650?text=${encodeURIComponent(mensagem)}`

										window.open(link, '_blank');

										this.setState({
											...this.state,
											modoTela: 'menu',
											registroReserva: {}
										});

										setTimeout(() => {
											window.scrollTo(0, 0);
										}, 20);
										
									}}>Enviar</button>
							</Grid>}
							<Grid cols='6 6 6 6'>
								<button 
									type='button'
									class='btn btn-block btn-dark btn-sm'
									onClick={() => {										
										this.setState({
											...this.state,
											modoTela: 'menu',
											registroReserva: {}
										});

										setTimeout(() => {
											window.scrollTo(0, 0);
										}, 20);
									}}>Voltar</button>
							</Grid>
						</Row>
					</Grid>
				</Row>
			</div>
		);
	}

	indique() {
		
		return (
			<div 
				style={{ 
					backgroundColor: 'rgba(255, 255, 255, 0.7)',
					padding: 4
				}}>

				<Row alignCenter>
					<Grid cols='12 6 4 3'>
						<Row>
							<LabelAndInput						
								label='Nome do Indicado:'
								placeholder=''
								cols='12 12 12 12'
								value={this.state.registroIndicar.nome}
								onChange={data => {
									this.setState({
										...this.state,
										registroIndicar: {
											...this.state.registroIndicar,
											nome: data.target.value
										}
									});
								}} />
							
							<LabelAndInputMask
								label='Celular do Indicado:'
								placeholder=''
								cols='12 12 12 12'
								value={this.state.registroIndicar.celular}
								mask='(99) 9 9999-9999'
								onChange={data => {
									this.setState({
										...this.state,
										registroIndicar: {
											...this.state.registroIndicar,
											celular: data.target.value
										}
									});
								}} />

							<Grid cols='6 6 6 6'>
								<button 
									type='button'
									class='btn btn-block btn-dark btn-sm'
									onClick={() => {

										let mensagem = 'Olá, quero indicar um amigo: \n'
											+ `\nNome: ${this.state.registroIndicar.nome}`
											+ `\nCelular: ${this.state.registroIndicar.celular}`;

										let link = `https://wa.me/554732691650?text=${encodeURIComponent(mensagem)}`

										window.open(link, '_blank');

										this.setState({
											...this.state,
											modoTela: 'menu',
											registroIndicar: {}
										});

										setTimeout(() => {
											window.scrollTo(0, 0);
										}, 20);
									}}>Enviar</button>
							</Grid>
							<Grid cols='6 6 6 6'>
								<button 
									type='button'
									class='btn btn-block btn-dark btn-sm'
									onClick={() => {										
										this.setState({
											...this.state,
											modoTela: 'menu',
											registroIndicar: {}
										});

										setTimeout(() => {
											window.scrollTo(0, 0);
										}, 20);
									}}>Voltar</button>
							</Grid>
						</Row>
					</Grid>
				</Row>
			</div>
		);
	}

	associar() {
		
		return (
			<div 
				style={{ 
					backgroundColor: 'rgba(255, 255, 255, 0.7)',
					padding: 4
				}}>

				<Row alignCenter>
					<Grid cols='12 6 4 3'>
						<Row>
							<LabelAndInput						
								label='Nome:'
								placeholder=''
								cols='12 12 12 12'
								value={this.state.registroAssociar.nome}
								onChange={data => {
									this.setState({
										...this.state,
										registroAssociar: {
											...this.state.registroAssociar,
											nome: data.target.value
										}
									});
								}} />
							
							<LabelAndInputMask
								label='Celular:'
								placeholder=''
								cols='12 12 12 12'
								value={this.state.registroAssociar.celular}
								mask='(99) 9 9999-9999'
								onChange={data => {
									this.setState({
										...this.state,
										registroAssociar: {
											...this.state.registroAssociar,
											celular: data.target.value
										}
									});
								}} />

							<Grid cols='6 6 6 6'>
								<button 
									type='button'
									class='btn btn-block btn-dark btn-sm'
									onClick={() => {

										let mensagem = 'Olá, quero me associar: \n'
											+ `\nNome: ${this.state.registroAssociar.nome}`
											+ `\nCelular: ${this.state.registroAssociar.celular}`;

										let link = `https://wa.me/554732691650?text=${encodeURIComponent(mensagem)}`

										window.open(link, '_blank');

										this.setState({
											...this.state,
											modoTela: 'menu',
											registroAssociar: {}
										});

										setTimeout(() => {
											window.scrollTo(0, 0);
										}, 20);
									}}>Enviar</button>
							</Grid>
							<Grid cols='6 6 6 6'>
								<button 
									type='button'
									class='btn btn-block btn-dark btn-sm'
									onClick={() => {										
										this.setState({
											...this.state,
											modoTela: 'menu',
											registroAssociar: {}
										});

										setTimeout(() => {
											window.scrollTo(0, 0);
										}, 20);
									}}>Voltar</button>
							</Grid>
						</Row>
					</Grid>
				</Row>
			</div>
		);
	}


	carteirinha() {

		if (this.props.usuarioCarregado && this.props.usuarioCarregado.id) {
			if (this.props.usuarioCarregado.id_tipo_contrato == 4 || this.props.usuarioCarregado.id_tipo_contrato == 5) {
				return this.carteirinhaBlack();
			} else {
				return this.carteirinhaOurocard();
			}

		} else {
			return null;
		}
	}

	carteirinhaOurocard() {

		let scale = 1;
		if (window.innerWidth > 360) {
			scale = ((window.innerWidth > 500 ? 500 : window.innerWidth) * 1) / 360;
		}

		const cardCartao = {
			backgroundColor: '#ffffff',
			width: 340,
			height: 200,
			borderRadius: 10,
			overflow: 'hidden',
			transform: `scale(${scale})`
		};

		const cardCartaoTitulo = {
			backgroundColor: '#0042E2',
			width: '100%',
			height: 50,
			fontSize: 18,
			fontWeight: 'bold',
			color: '#ffffff',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center'
		};

		const cardCartaoNumero = {
			backgroundColor: '#FFCC00',
			width: '100%',
			height: 50,
			fontSize: 14,
			fontWeight: 'bold',
			color: '#0042E2',
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center',
			paddingLeft: 8,
			paddingRight: 8
		};

		const cardCartaoData = {
			backgroundColor: '#FFFFFF',
			width: '100%',
			height: 50,
			display: 'flex',
			color: '#0042E2',
			justifyContent: 'space-between',
			alignItems: 'center',
			paddingLeft: 8,
			paddingRight: 8,
			fontSize: 14
		};
		
		const cardCartaoNome = {
			backgroundColor: '#FFFFFF',
			width: '100%',
			height: 50,
			display: 'flex',
			color: '#0042E2',
			justifyContent: 'space-between',
			alignItems: 'center',
			paddingLeft: 8,
			paddingRight: 8,
			fontSize: 14,
			fontWeight: 'bold'
		};
		
		return (
			<div>
				<div 
					style={{ 
						display: 'flex',
						justifyContent: 'center',
						paddingTop: 40 * scale
					}}>

					<div style={cardCartao}>
						<div style={cardCartaoTitulo}>
							OURO CARD HOSPEDAGEM
						</div>
						<div style={cardCartaoNumero}>
							<div style={{ width: '60%', textAlign: 'center' }}>
								SEGURANÇA E ECONOMIA
							</div>
							<div style={{ width: 80, backgroundColor: '#ffffff', textAlign: 'center', padding: 2 }}>
								N° {this.props.usuarioCarregado.numero_contrato}
							</div>
						</div>
						<div style={cardCartaoData}>
							<div style={{ width: '50%', textAlign: 'center' }}>
								{this.props.usuarioCarregado.alta_temporada}
							</div>
							<div style={{ width: '50%', textAlign: 'right' }}>
								<div style={{ fontSize: 10 }}>DATA DA ASSOCIAÇÃO</div>
								<div>{this.props.usuarioCarregado.data_associacao}</div>
							</div>						
						</div>
						<div style={cardCartaoNome}>
							<div style={{ marginLeft: 40, width: 300, textAlign: 'center' }}>
								{this.props.usuarioCarregado.nome}
							</div>
							<img src={imagemSoLogoColorida}
								style={{
									width: 40,
									height: 40
								}} />

						</div>
					</div>
				</div>

				<Row alignCenter style= {{ marginTop: 40 * scale }}>
					<Grid cols='12 6 4 3'>
						<Row alignCenter>							
							<Grid cols='6 6 6 6'>
								<button 
									type='button'
									class='btn btn-block btn-dark btn-sm'
									onClick={() => {										
										this.setState({
											...this.state,
											modoTela: 'menu',
											registroIndicar: {}
										});

										setTimeout(() => {
											window.scrollTo(0, 0);
										}, 20);
									}}>Voltar</button>
							</Grid>
						</Row>
					</Grid>
				</Row>
			</div>
		);
	}

	carteirinhaBlack() {

		let scale = 1;
		if (window.innerWidth > 360) {
			scale = ((window.innerWidth > 500 ? 500 : window.innerWidth) * 1) / 360;
		}

		const cardCartao = {
			backgroundColor: '#000000',
			width: 340,
			height: 200,
			borderRadius: 10,
			overflow: 'hidden',
			transform: `scale(${scale})`
		};

		const cardCartaoTitulo = {
			backgroundColor: '#000000',
			width: '100%',
			height: 90,
			fontSize: 18,
			fontWeight: 'bold',
			color: '#ffffff',
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center'
		};

		const cardCartaoNumero = {
			backgroundColor: '#000000',
			width: '100%',
			height: 70,
			fontSize: 18,
			fontWeight: 'bold',
			color: '#ffffff',
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center'
		};

		const cardCartaoLogos = {
			backgroundColor: '#ffffff',
			width: 324,
			height: 30,
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center',
			marginLeft: 8,
			marginRight: 8,
			paddingLeft: 4,
			paddingRight: 4,
			marginTop: 4,
			borderRadius: 4
		};
		
		return (
			<div>
				<div 
					style={{ 
						display: 'flex',
						justifyContent: 'center',
						paddingTop: 40 * scale
					}}>

					<div style={cardCartao}>
						<div style={cardCartaoTitulo}>
							<img src={imagemSoLogoAmarela}
								style={{
									width: 80,
									height: 80,
									marginLeft: 10
								}} />
							
							<div style={{ height: '100%', textAlign: 'center', fontWeight: 'bold', paddingTop: 8 }}>
								<div  style={{ fontSize: 14 }}>CARTÃO BLACK</div>
								<div style={{ fontSize: 10 }}>FÉRIAS ILIMITADAS</div>
							</div>

							<div style={{ width: 90, height: '100%', textAlign: 'left', display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingRight: 8 }}>
								<div style={{ fontSize: 14, fontWeight: 'bold' }}>N° {this.props.usuarioCarregado.numero_contrato}</div>
								<div style={{ fontSize: 8 }}>DATA ASSOCIAÇÃO</div>
								<div style={{ fontSize: 8 }}>{this.props.usuarioCarregado.data_associacao}</div>
							</div>
						</div>
						<div style={cardCartaoNumero}>
							<div style={{ height: '100%', textAlign: 'left', display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingLeft: 10 }}>
								<div style={{ fontSize: 14 }}>SEGURANÇA E ECONOMIA</div>								
								<div style={{ fontSize: 10 }}>uso ilimitado</div>
								<div style={{ fontSize: 11, marginTop: 2 }}>{this.props.usuarioCarregado.nivel_cliente}</div>
								<div style={{ fontSize: 12 }}>{this.props.usuarioCarregado.nome}</div>
							</div>
							
							<img src={`https://api.qrserver.com/v1/create-qr-code/?size=60x60&data=${this.props.usuarioCarregado.numero_contrato}`}
								style={{
									width: 60,
									height: 60,
									marginRight: 20
								}} />
						</div>
						<div style={cardCartaoLogos}>

							<img src={logoSaoJoao}
								style={{
									maxHeight: 20,
									height: 'auto',
									maxWidth: 40,
									width: 'auto'
								}} />
							
							<img src={logoTurismoResponsavel}
								style={{
									maxHeight: 20,
									height: 'auto',
									maxWidth: 40,
									width: 'auto'
								}} />
							
							<img src={logoMsc}
								style={{
									maxHeight: 20,
									height: 'auto',
									maxWidth: 40,
									width: 'auto'
								}} />
							
							<img src={logoAzul}
								style={{
									maxHeight: 20,
									height: 'auto',
									maxWidth: 40,
									width: 'auto'
								}} />
							
							<img src={logoGol}
								style={{
									maxHeight: 20,
									height: 'auto',
									maxWidth: 40,
									width: 'auto'
								}} />
							
							<img src={logoLatam}
								style={{
									maxHeight: 20,
									height: 'auto',
									maxWidth: 40,
									width: 'auto'
								}} />
							
						</div>
						
					</div>
				</div>

				<Row alignCenter style= {{ marginTop: 40 * scale }}>
					<Grid cols='12 6 4 3'>
						<Row alignCenter>							
							<Grid cols='6 6 6 6'>
								<button 
									type='button'
									class='btn btn-block btn-dark btn-sm'
									onClick={() => {										
										this.setState({
											...this.state,
											modoTela: 'menu',
											registroIndicar: {}
										});

										setTimeout(() => {
											window.scrollTo(0, 0);
										}, 20);
									}}>Voltar</button>
							</Grid>
						</Row>
					</Grid>
				</Row>
			</div>
		);
	}

	setParques(acessar) {
		this.setState({
			acessarParques: acessar
		});
	}

	parques() {
		if (!this.state.acessarParques) {
			return null;
		}

		return (
			<div class='modal fade show' id='modal-default' 
				style={{ display: 'block', paddingRight: 15 }} 
				aria-modal='true' role='dialog'>
				<div class='modal-dialog'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>Selecione</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close'
								onClick={() => this.setParques(false)}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body'>
							<Row alignCenter>
								<Grid cols='12 12 12 12'>
									<button type='button' 
										class='btn btn-block bg-gradient-dark btn-lg'
										style={{ marginTop: 24, marginBottom: 24 }}
										onClick={() => {
											window.open('https://parksnet.com.br/destino/santa-catarina?bookingAgency=5711&cupom=VIVAHOSPEDAGEM', '_blank');
											this.setParques(false);
										}}>
										Parques em Santa Catarina
									</button>
									<button type='button' 
										class='btn btn-block bg-gradient-dark btn-lg'
										style={{ marginTop: 24, marginBottom: 24 }}
										onClick={() => {
											window.open('https://parksnet.com.br/destino/serra-gaucha?bookingAgency=5704&cupom=VIVAHOSPEDAGEM', '_blank');
											this.setParques(false);
										}}>
										Parques na Serra Gaúcha
									</button>
								</Grid>
							</Row>
						</div>
					</div>
				</div>
			</div>
		)
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado || {},
	aguardando: state.dashboard.aguardando,
	linkBeneficiario: state.dashboard.linkBeneficiario
});
const mapDispatchToProps = dispatch => bindActionCreators({
	enviarMensagem, carregarLinkBeneficio
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
